interface LiveRegionProps {
  announcing?: boolean;
  message?: string;
}

/**
 * Screen-reader-only live region for announcements.
 */
export default function LiveRegion({
  announcing = false,
  message = "",
}: LiveRegionProps) {
  return (
    <div className="sr-only" role="status" aria-live="polite">
      {announcing ? message : ""}
    </div>
  );
}
